import { isEqual } from 'lodash-es';
import type { TransactionModifiersForm } from '../CreateTransactionRuleModal';
import { useEditTransactionRuleContext } from './EditTransactionRuleContext';

type FormField = keyof TransactionModifiersForm;

const formFields: FormField[] = [
  'name',
  'description',
  'selectors',
  'headers',
  'dynamicResponseModifiers',
  'response',
  'representationType',
  'representationFields',
  'customModifier',
];

const normalizeFieldValue = <T extends keyof TransactionModifiersForm>(
  field: TransactionModifiersForm[T]
) => {
  // Normalize field value to string to compare with default value.
  if (typeof field !== 'string') {
    return field;
  }
  try {
    // Remove whitespaces and newlines from string values.
    return JSON.stringify(JSON.parse(field));
  } catch {
    return field;
  }
};

export const useFormDirtyFields = () => {
  const { form } = useEditTransactionRuleContext();

  const findDirtyFields = (fields = formFields) => {
    // Compare fileds with thier defaultValues to check if they are changed.
    return fields.reduce<FormField[]>((acc, fieldName) => {
      const defaultFieldValue = form.formState.defaultValues[
        fieldName
      ] as TransactionModifiersForm[FormField];
      const currentFieldValue = form.getValues(fieldName);

      if (
        !isEqual(
          normalizeFieldValue(currentFieldValue),
          normalizeFieldValue(defaultFieldValue)
        )
      ) {
        acc.push(fieldName);
      }

      return acc;
    }, []);
  };

  const isFormDirty = () => {
    return findDirtyFields().length > 0;
  };

  return {
    isFormDirty,
    findDirtyFields,
  };
};
